import { useResetPassword } from "@/hooks/auth-hook";
import { LoginProps } from "@/types/main-types";
import { useTranslations } from "next-intl";
import { useRouter } from "next/navigation";
import { useForm } from "react-hook-form";

export default function Reset() {
  const t = useTranslations("Auth");
  const { mutate, isPending } = useResetPassword();
  const router = useRouter();

  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  }: any = useForm({ mode: "all" });

  const handleResetPassword = (data: LoginProps) => {
    mutate(data, {
      onSuccess: () => {
        router.push("/auth/login");
      },
    });
  };

  const emailValue = watch("email", "");

  return (
    <div className="flex-1 flex items-center justify-center px-6 md:px-10 relative lg:min-h-screen">
      <div className="w-full max-w-md  transition-all duration-300">
        <h2 className="text-3xl font-bold text-main mb-8 text-center">
          {t("resetPassword")}
        </h2>

        <p className="text-sm text-center mb-6 text-dark">{t("resetDes")}</p>

        <form
          onSubmit={handleSubmit(handleResetPassword)}
          className="space-y-4"
        >
          {/* Email Field */}
          <div className="relative">
            <input
              type="text"
              id="email"
              {...register("email", {
                required: "EmailRequired",
                pattern: {
                  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message: "InvalidEmailAddress",
                },
              })}
              className={`peer w-full border rounded-lg px-3 pt-6 pb-2 text-left text-sm outline-none transition-all duration-200
      ${
        errors.email ? "border-red-500 " : "border-gray-300 focus:border-main"
      }`}
              placeholder=" "
              autoComplete="off"
            />
            <label
              htmlFor="email"
              className={`absolute left-3 bg-white px-1 text-gray-500 text-sm transition-all duration-200
      ${emailValue ? "top-1 text-xs" : "top-3.5 text-gray-400"}
      peer-focus:top-1 peer-focus:text-[10px] peer-focus:text-main`}
            >
              {t("emailAddress")}
            </label>
          </div>

          <button
            disabled={isPending}
            type="submit"
            className="w-full cursor-pointer bg-main text-white py-3 rounded-lg font-medium hover:bg-main/90 transition-all duration-300 shadow-md hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
          >
            {t("resetPassword")}
          </button>
        </form>
      </div>
    </div>
  );
}
